import React from 'react';
import { Button, Label, Popup } from 'semantic-ui-react';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';
import { GROUP_LOGOS } from 'constants/constants';

export default function GroupPopup({
  group,
  agencies,
  activeAgencies,
  onToggleAgency,
}) {
  const agencyOptions = agencies.filter((agency) => agency.group === group);

  const activeAgenciesInGroup = activeAgencies.filter((agency) =>
    agencyOptions.map((agency) => agency.id).includes(agency),
  );

  return (
    <Popup
      trigger={
        <Label basic className="carrier-logo-group" title={group}>
          {GROUP_LOGOS[group] ? (
            <img src={GROUP_LOGOS[group]} alt={group} />
          ) : (
            <div>OTROS</div>
          )}
          <span>{activeAgenciesInGroup.length}</span>
        </Label>
      }
      content={
        <div className="group-popup__buttons" role="listbox">
          {agencyOptions.map((agency) => (
            <Button
              className="agencies-filters__filter"
              key={agency.id}
              toggle
              circular
              active={activeAgencies?.includes(agency.id)}
              size="mini"
              onClick={(event, data) => {
                onToggleAgency(agency.id);
              }}
            >
              <CarrierLogo code={agency.agency_code} />
            </Button>
          ))}
        </div>
      }
      on="hover"
      mouseEnterDelay={500}
      hoverable
      className="group-popup__popup"
    />
  );
}
